import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';
import { UnrealBloomPass } from "three/examples/jsm/postprocessing/UnrealBloomPass";
import * as THREE from "three";
export class PostProcessing {
    constructor(scene) {
        const composer = new EffectComposer(scene.renderer);
        composer.setSize(window.innerWidth, window.innerHeight);
        this.composer = composer;
        const bloomPass = new UnrealBloomPass(new THREE.Vector2(window.innerWidth, window.innerHeight), 0.5, 0, 0.21);
        const renderPass = new RenderPass(scene.threeScene, scene.camera.threeCamera);
        bloomPass.renderToScreen = true;
        this.composer.addPass(renderPass);
        this.composer.addPass(bloomPass);
    }
}
